import React, { useState } from "react";
import QRScanner from "../components/QRScanner";
import axios from "axios";
import TopBar from "../components/TopBar";
import BottomBar from "../components/BottomBar";
import { FaSyncAlt, FaArrowLeft, FaMobileAlt, FaQrcode } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Hashids from "hashids";

const hashids = new Hashids("sup_2025_user_secure_5@!%", 10);

const GivePointPage = () => {
  const [method, setMethod] = useState(null); // 'scan' or 'manual'
  const [phone, setPhone] = useState("");
  const [member, setMember] = useState(null);
  const [amount, setAmount] = useState("");
  const [points, setPoints] = useState(null);
  const [showScanner, setShowScanner] = useState(false);

  const navigate = useNavigate();

  const fetchMember = async (phoneValue) => {
    try {
      if (phoneValue) {
        const res = await axios.get(`https://api.superpetshop.com/api/v1/member/by-phone?phone=${phoneValue}`);
        setMember(res.data);
      }
    } catch (err) {
      setMember(null);
      alert("ไม่พบสมาชิกในระบบ");
    }
  };

  const handleScan = (text) => {
    try {
      const decoded = hashids.decode(text);
      if (!decoded.length || decoded.length < 2) {
        alert("ไม่สามารถถอดรหัส QR ได้");
        return;
      }

      const phoneDecoded = "0" + decoded[1]; // เช่น 0812345678
      setPhone(phoneDecoded);
      setPoints(null);
      setShowScanner(false);
      fetchMember(phoneDecoded);
    } catch (error) {
      alert("เกิดข้อผิดพลาดในการสแกน QR");
      console.error("QR Decode error:", error);
    }
  };

  const handleSubmit = async () => {
    if (!phone || !amount) {
      alert("กรุณาสแกนหรือกรอกเบอร์ และกรอกยอดก่อน");
      return;
    }

    const token = localStorage.getItem("token"); // หรือ sessionStorage แล้วแต่ที่ใช้

    try {
      const res = await axios.post(
        "https://api.superpetshop.com/api/v1/point/add-point-from-amount",
        {
          phone: phone,
          amount: Number(amount),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setPoints(res.data.points);
      alert(`✅ ให้พอยท์สำเร็จ: ${res.data.points} พอยท์`);
      handleReset(); // 👉 เคลียร์ข้อมูลทั้งหมด
    } catch (err) {
      alert("เกิดข้อผิดพลาด: " + (err.response?.data?.message || err.message));
    }
  };

  const handleBack = () => {
    navigate("/menu");
  };

  const handleReset = () => {
    setPhone("");
    setMember(null);
    setAmount("");
    setPoints(null);
    setMethod(null);
    setShowScanner(false);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <TopBar />

      <div className="flex flex-col flex-1 p-4 bg-gray-100">
        <h2 className="text-lg font-bold mb-4 text-center">ให้พอยท์ลูกค้า</h2>

        {!method && (
          <div className="grid gap-4 mb-4 mx-8">
            <button
              onClick={() => {
                setMethod("scan");
                setShowScanner(true);
              }}
              className="bg-blue-500 text-white text-2xl p-4 rounded w-full mb-4 grid items-center justify-center gap-2"
            >
              <FaQrcode className="text-8xl"/>
              สแกน QR
            </button>
            <button
              onClick={() => setMethod("manual")}
              className="bg-indigo-500 text-white text-2xl p-4 rounded w-full mb-4 grid items-center justify-center gap-2"
            >
              <FaMobileAlt className="text-8xl"/>
              กรอกเบอร์
            </button>
          </div>
        )}

        {method === "scan" && showScanner && <QRScanner onScan={handleScan} />}

        {method === "manual" && (
          <div className="mb-4">
            <input
              className="border p-2 w-full rounded"
              placeholder="เบอร์โทรศัพท์"
              inputMode="numeric"
              maxLength={10}
              value={phone}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // ลบ non-digit
                setPhone(value);
              }}
              onBlur={(e) => {
                if (e.target.value.length === 10) {
                  fetchMember(e.target.value);
                }
              }}
            />
          </div>
        )}

        {member && (
          <div className="text-center mb-4">
            <p className="font-semibold">ชื่อสมาชิก: {member.firstname} {member.lastname}</p>
            <p className="font-semibold">เบอร์: {member.phone}</p>
          </div>
        )}

        {method && (
          <>
            <input
              type="number"
              className="border p-2 w-full my-3 rounded"
              placeholder="ยอดซื้อ (บาท)"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />

            <button
              className="bg-green-500 text-white w-full p-2 rounded disabled:opacity-50"
              onClick={handleSubmit}
              disabled={!member?.id || !amount}
            >
              ยืนยันให้พอยท์
            </button>

            {points !== null && (
              <p className="text-center mt-2 text-green-600">
                ✅ พอยท์ที่เพิ่ม: {points}
              </p>
            )}

            <button
              className="bg-gray-500 text-white w-full p-2 rounded mt-4 flex items-center justify-center gap-2"
              onClick={handleReset}
            >
              <FaSyncAlt /> เริ่มใหม่
            </button>
          </>
        )}

        <button
          className="mt-6 text-gray-600 flex justify-center items-center gap-2 underline"
          onClick={handleBack}
        >
          <FaArrowLeft /> กลับ
        </button>
      </div>

      <BottomBar />
    </div>
  );
};

export default GivePointPage;
